/**
 * @generated SignedSource<<a9f88220465a4eb8058d5e3fc77e59a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SessionProviderSignOutMutation$variables = Record<PropertyKey, never>;
export type SessionProviderSignOutMutation$data = {
  readonly signOut: {
    readonly ok: boolean;
  } | null | undefined;
};
export type SessionProviderSignOutMutation = {
  response: SessionProviderSignOutMutation$data;
  variables: SessionProviderSignOutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "input",
        "value": {}
      }
    ],
    "concreteType": "SignOutPayload",
    "kind": "LinkedField",
    "name": "signOut",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": "signOut(input:{})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionProviderSignOutMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SessionProviderSignOutMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a872d951311fa953aebb98d5c6f4f71e",
    "id": null,
    "metadata": {},
    "name": "SessionProviderSignOutMutation",
    "operationKind": "mutation",
    "text": "mutation SessionProviderSignOutMutation {\n  signOut(input: {}) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "e4efdaab6d9e77e7d3471ffb217cc093";

export default node;
